import { defineComponent as _defineComponent } from 'vue'
import Vue, { nextTick, ref } from 'vue';

import Dropdown from '@/shared/components/Dropdown.vue';

type Year = typeof years[number];

type RowKey = typeof rows[number]['key'];

type SelectedData = Record<Year, Record<RowKey, boolean | null>>;


export default /*#__PURE__*/_defineComponent({
  __name: 'PlantProtectionContractForm',
  setup(__props, { expose }) {

const dropdownRefs = ref<Record<string, Vue | null>>({});

const years = ['2023', '2024'] as const;
const rows = [
  { label: 'Bewirtschaftungsform Bio', key: 'organicFarming' },
  { label: 'Herbizidverzicht Wein Obst Hopfen', key: 'noHerbicideWineFruitHops' },
  { label: 'Insektizidverzicht Wein Obst Hopfen', key: 'noInsecticideWineFruitHops' },
] as const;
const selected = ref<SelectedData>({
  2023: {
    organicFarming: null,
    noHerbicideWineFruitHops: null,
    noInsecticideWineFruitHops: null,
  },
  2024: {
    organicFarming: null,
    noHerbicideWineFruitHops: null,
    noInsecticideWineFruitHops: null,
  },
});

const submitted = ref(false);

const isValid = () =>
  Object.values(selected.value['2023']).every((val) => val !== null) &&
  Object.values(selected.value['2024']).every((val) => val !== null);

const handleSubmit = () => {
  submitted.value = true;

  if (!isValid()) {
    scrollToFirstInvalid();
    return null;
  }

  const rowKeys: RowKey[] = ['organicFarming', 'noHerbicideWineFruitHops', 'noInsecticideWineFruitHops'];

  const result: {
    processOrderData: Record<string, Record<string, boolean | null>>;
  } = {
    processOrderData: {
      '2023': {},
      '2024': {},
    },
  };

  years.forEach((year) => {
    rowKeys.forEach((key) => {
      result.processOrderData[year][key] = selected.value[year][key];
    });
  });

  return result;
};

function setDropdownRef(el: any, key: string) {
  if (el) {
    dropdownRefs.value[key] = el;
  }
}

function scrollToFirstInvalid() {
  nextTick(() => {
    years.some((year) =>
      rows.some((row) => {
        if (selected.value[year][row.key] === null) {
          const refKey = `${year}-${row.key}`;
          const el = dropdownRefs.value[refKey]?.$el;
          if (el?.scrollIntoView) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return true;
        }
        return false;
      }),
    );
  });
}

const dropdownOptions = [
  { id: null, name: 'auswählen', value: null },
  { id: true, name: 'Ja', value: true },
  { id: false, name: 'Nein', value: false },
];

function dropdownItems(selectedValue: any) {
  return {
    data: [
      {
        name: '',
        items: dropdownOptions,
      },
    ],
    loading: false,
    selected: dropdownOptions.find((opt) => opt.value === selectedValue) || { id: null, name: '', value: null },
  };
}

function getSelected(year: Year, key: RowKey) {
  return selected.value[year][key];
}

function updateSelected(year: Year, key: RowKey, value: boolean | null) {
  selected.value[year][key] = value;

  const otherYear = year === '2023' ? '2024' : '2023';
  if (selected.value[otherYear][key] === null) {
    selected.value[otherYear][key] = value;
  }
}

expose({
  handleSubmit,
});

return { __sfc: true,dropdownRefs, years, rows, selected, submitted, isValid, handleSubmit, setDropdownRef, scrollToFirstInvalid, dropdownOptions, dropdownItems, getSelected, updateSelected, Dropdown }
}

})